import React, { useContext, useEffect, useRef, useState } from 'react';
import Betslip from '../common/Betslip';
import Menu from '../common/menu/Menu';
import LiveContext from '../contexts/LiveContext';
import MainContext from '../contexts/MainContext';
import PrematchContext from '../contexts/PrematchContext';
import { MAX_COLUMNS } from '../data/constants';
import { existsCountry, existsSport, existsTournament } from '../data/data';
import { initStatsUtils } from '../data/sport-utils';
import { getConfiguration, getFavoriteTournamentsData, getTorneiInEvidenza } from '../data/utils';
import { CustomCols } from '../live/Live';
import { initTables, setAvailableSpaceForTables } from '../tables-utils';
import ExtraEvents from './extra-events/ExtraEvents';
import PrematchFavoriteOdds from './favorite-odds/PrematchFavoriteOdds';
import MatchSearchPopup from './MatchSearchPopup';
import MatchesBydate from './matches-by-date/MatchesByDate';
import PrematchEmpty from './prematch-home/PrematchEmpty';
import PrematchHome from './prematch-home/PrematchHome';
import PrematchNoEvents from './prematch-home/PrematchNoEvents';
import { PrematchDataContext } from './PrematchDataFetcher';
import PrintOdds from './print-odds/PrintOdds';
import Selection from './selection/Selection';
import TopMatch from './top-match/TopMatch';
import FavoriteTournamentsProvider, { getFavoriteTournaments } from './favorite-tournaments/FavoriteTournamentsProvider';
import PrematchLanding from './PrematchLanding';
import ResultsFetcher from './event-search/ResultsFetcher';
import { useTimeline } from './TimelineProvider';

// non toccare i commenti relativi a GeniusStreamingV3. Servono per testare le fixtures a bisogno
//import GeniusStreamingV3 from '../data/streaming/GeniusStreamingV3';
//import { getBetgeniusV3StreamingProps } from '../data/streaming/streamingUtils';

function getFavoriteAndHighlightedTournaments(data) {
    const favoriteTournaments = getFavoriteTournaments(data);
    const favoriteTournamentsData = getFavoriteTournamentsData(data.sport, favoriteTournaments, 'ALL');
    let inEvidenza = getTorneiInEvidenza(data.sport, 'ALL');
    
    const set = new Set();
    favoriteTournamentsData.tournamentsIds.concat(inEvidenza.tournamentsIds).forEach(t => set.add(t));
    const tournaments = Array.from(set);
    return tournaments;
}

function getFirstTournamentUniqueId(data) {
    return data.sport[0].categories[0].tournaments[0].uniqueId;
}

function handleLandFromBanner() {
    let item = localStorage.getItem('land-from-banner');
    if (item) {
        item = JSON.parse(item);
        item.openedFromBanner = true;
        return item;
    }
    return null;
}

function Prematch(props) {

    const conf = getConfiguration();
    const mainContext = React.useContext(MainContext);
    const prematchDataContext = React.useContext(PrematchDataContext);
    const liveContext = useContext(LiveContext);
    const handledOpenFromPath = useRef(false);
    const timeLineData = useTimeline();

    

    const [[section, selectedTournaments, openCollapsed]] = useState(() => {
        let selectedTournaments = [], section = 'top-match', openCollapsed = false;
        const landingType = conf.pls;
        if (landingType === 'TOP_TOURN') {
            section = 'prematch-home';
            selectedTournaments = getFavoriteAndHighlightedTournaments(prematchDataContext);
            openCollapsed = conf.sctc;
        } else if (landingType === 'FIRST_TOURN') {
            section = 'prematch-home';
            selectedTournaments = [getFirstTournamentUniqueId(prematchDataContext)];
        } else if (landingType === 'SPORT_PAGE_SEL') {
            section = 'selection-menu';
        } else if (landingType.startsWith('TOURN_')) {
            section = 'prematch-home';
            const parts = landingType.split('TOURN_');
            let tournamentId = parts[1];
            if (prematchDataContext.tournamentByUniqueId[tournamentId] == null) {
                tournamentId = getFirstTournamentUniqueId(prematchDataContext);
            }
            selectedTournaments = [tournamentId];
        }

        return [section, selectedTournaments, openCollapsed];
    });

    const [context, setContext] = useState({
        section,
        selections: [],
        selectedTournaments,
        openCollapsed,
        tournamentsToPrint: null,
        daySelection: null,
        daySport:null,
        dayCountry:null,
        match: handleLandFromBanner(),
        temporalFilter: 'ALL',
        goBackToMatchesByDate: false,
        searchData: null,
        update(updt) {
            setContext(prev => {
                return {...prev, ...updt};
            });
        },
        reset() {
            this.update({
                section: section,
                selections: [],
                selectedTournaments: selectedTournaments,
                daySelection: null,
                match: null
            });
        },
        openPrematchNoEvents(){
            this.update({section: 'prematch-no-events', selections: null});
        },
        openSelectionMenu(sportId, countryId) {
        	if (!window.appConfig.SHOP_MODE) {
                const selections = {
                    sport: null,
                    country: null,
                };
                if (sportId != null) {
                    selections.sport = sportId;
                    if (countryId != null) {
                        selections.country = countryId;
                    }
                }
                this.update({section: 'selection-menu', selections});
        	}
        },
        openSportOverview : function (){
            const selections = {
                    sport: null,
                    country: null,
            };
        	this.update({section: 'selection-menu', selections});
        },
        closeSelectionMenu() {
            this.update({section: 'prematch-home', selections: null});
        },
        
        setBetBuilderTournamentOpened(betBuilderTournamentOpened){
        	let selectedTournaments = this.selectedTournaments;
        	if(betBuilderTournamentOpened){
        		// new array with just this tournament: it must be the only one opened
        		selectedTournaments = [betBuilderTournamentOpened];
        	}
        	this.betBuilderTournamentOpened = betBuilderTournamentOpened;
        	this.selectedTournaments = selectedTournaments;
        	this.update({
        		betBuilderTournamentOpened,
        		selectedTournaments
        	});
        },
        
        toggleTournament(tournamentUniqueId, goBackToMatchesByDate = false) {
            //if there is a bet builder tournament opened different respect this one, I close it for first
            if(this.betBuilderTournamentOpened && tournamentUniqueId !== this.betBuilderTournamentOpened){
            	this.toggleTournament(this.betBuilderTournamentOpened, goBackToMatchesByDate);
            	this.setBetBuilderTournamentOpened(null);
            }
            const tournaments = this.selectedTournaments;
            const index = this.selectedTournaments.indexOf(tournamentUniqueId);
            if (index === -1) {
                tournaments.unshift(tournamentUniqueId);
                const primoBloccoSport = document.getElementById('primo-blocco-sport');
                if(primoBloccoSport){
	                primoBloccoSport.scrollTo({top: 0, behavior: 'smooth'});
                }
            } else {
                tournaments.splice(index, 1);
            }

            if (goBackToMatchesByDate) {
                if (tournaments.length === 0) {
                    this.update({
                        section: 'daily-match',
                        selectedTournaments: tournaments.slice(),
                        openCollapsed: false,
                        match: null,
                        goBackToMatchesByDate: false
                    });
                } else {
                    this.update({
                        section: 'prematch-home',
                        selectedTournaments: tournaments.slice(),
                        openCollapsed: false,
                        match: null,
                        goBackToMatchesByDate
                    });
                }
            } else if (tournaments.length === 0) {
                this.update({
                    section: this.goBackToMatchesByDate ? 'daily-match' : 'top-match',
                    selectedTournaments: tournaments.slice(),
                    openCollapsed: false,
                    match: null,
                    daySelection: this.goBackToMatchesByDate ? this.daySelection : null,
                    goBackToMatchesByDate
                });
            } else {
                this.update({
                    section: 'prematch-home',
                    selectedTournaments: tournaments.slice(),
                    openCollapsed: false,
                    match: null,
                    daySelection: null,
                    goBackToMatchesByDate
                });
            }
        },
        closeAllTournaments() {
            if (this.goBackToMatchesByDate) {
                this.update({
                    section: 'daily-match',
                    selectedTournaments: [],
                    match: null,
                    goBackToMatchesByDate: false
                });
            } else {
                this.update({
                    section: 'prematch-home',
                    selectedTournaments: [],
                    match: null,
                    daySelection: null
                });
            }
        },
        isTournamentSelected(tournamentUniqueId) {
            return this.selectedTournaments.indexOf(tournamentUniqueId) !== -1;
        },
        setTournaments(tournaments) {
            this.update({
                section: 'prematch-home',
                selectedTournaments: tournaments.slice(),
                openCollapsed: false,
                match: this.match?.openedFromBanner ? this.match : null
            });
        },
        openTournaments(tournaments) {
            this.update({
                section: 'prematch-home',
                selectedTournaments: tournaments.slice(),
                openCollapsed,
                match: null
            });
        },
        setDaySelection(day) {
            this.update({
                section: 'daily-match',
                selectedTournaments: [],
                match: null,
                daySelection: day,
                goBackToMatchesByDate: false
            });
        },
        setDaySportSelection(daySport) {
            this.update({section: '',daySport});
        },
        setDayCountrySelection(dayCountry) {
            this.update({section: '',dayCountry});
        },
        setDaySport(daySport) {
            this.update({daySport});
        },
        setDayCountry(dayCountry) {
            this.update({dayCountry});
        },
        openEvent(tournamentUniqueId, match) {
            this.update({
                section: 'prematch-home',
                selectedTournaments: [tournamentUniqueId],
                match,
                goBackToMatchesByDate: false
            });
        },
        openPrintOdds(tournamentsToPrint) {
            this.update({section: 'print-odds', tournamentsToPrint});
        },
        openPrintExtraOdds(data) {
            this.update({section: 'print-extra-odds', tournamentsToPrint: null, extraOdds: data});
        },
        setTemporalFilter(temporalFilter) {
            this.update({temporalFilter});
        },
        openFavoriteOdds() {
            this.update({
                section: 'favorite-odds'
            });
        },
        openExtraEvents() {
            this.update({
                section: 'extra-events',
                selectedTournaments: []
            });
        },
        openSearch(searchData) {
            this.update({
                section: 'event-search',
                searchData
            });
        },
    });

    function openMatchLive(sport, country, tournament, match) {
        liveContext.setMatchData({
            sportId: sport,
            countryId: country,
            tournamentId: tournament,
            matchId: match
        }, true);
        window.openSection('live-match');
    }

    const firstRender = useRef(true);
    if (firstRender.current === true) {
        firstRender.current = false;
        mainContext.reloadPrematch = context.reset.bind(context);
    }

    const data = prematchDataContext;

    useEffect(() => {
        const historyBackPressed = mainContext.historyBackPressed;
        if (props.openFromPath && (!handledOpenFromPath.current || historyBackPressed) && data) {
            const pathData = props.openFromPath;
            const selectionsEmpty = (context.selections == null || context.selections.length === 0);
            if (pathData.sport && (selectionsEmpty || historyBackPressed) ) {
                const s = pathData.sport;
                const _existsSport = existsSport(data, s.sportId);
                if (_existsSport) {
                    context.openSelectionMenu(s.sportId, null);
                }else if (conf.seo) {
                    context.openPrematchNoEvents();
                }
            } else if (pathData.country && (selectionsEmpty || historyBackPressed) ) {
                const c = pathData.country;
                const _existsSport = existsSport(data, c.sportId);
                const _existsCountry = existsCountry(data, c.sportId, c.countryId);
                if (_existsSport && _existsCountry) {
                    context.setDaySportSelection(c.sportId);
                    context.setDayCountrySelection(c.countryId)
                }else if (conf.seo) {
                    context.openPrematchNoEvents();
                }
                /*if(_existsCountry){
                    context.openSelectionMenu(props.openFromPath.country.sportId, props.openFromPath.country.countryId);
                }*/
            } else if (pathData.tournament) {
                const t = pathData.tournament;
                const uniqueId = `${t.sportId}_${t.countryId}_${t.tournamentId}`;
                const _existsTournament = existsTournament(data, t.sportId, t.countryId, t.tournamentId);
                if (_existsTournament /*&& !context.selectedTournaments.includes(uniqueId)*/) {
                    context.setTournaments([uniqueId]);
                }else if (conf.seo) {
                    if(conf.seoplesu) {
                        liveContext.setMatchDataPalAvv({
                            sportId: pathData.tournament.sportId,
                            countryId: pathData.tournament.countryId,
                            tournamentId: pathData.tournament.tournamentId,
                            pal: pathData.match.pal,
                            avv: pathData.match.avv
                        }, true);
                        let callback;
                        if(conf.seoplesu){
                            const locationPathname = new String( window.location.pathname);
                            callback = () =>{
                                setTimeout(() => {
                                    window.history.replaceState(window.history.state, null, locationPathname);
                                }, 5)
                            } 
                        }
                        window.openSection('live-match',callback);
                    }else{
                        context.openPrematchNoEvents();
                    }
                }
            }
            handledOpenFromPath.current = true;
        } else if (mainContext.prematchEventToOpen != null) {
        	const matchOpening = mainContext.prematchEventToOpen;
        	const tournamentUniqueId = `${matchOpening.sportRef}_${matchOpening.categoryRef}_${matchOpening.tournamentRef}`;
        	context.openEvent(tournamentUniqueId, matchOpening);
        	mainContext.setPrematchEventOpened();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data, mainContext.prematchEventToOpen, props.openFromPath]);

    useEffect(function() {
       if (window.appConfig && window.appConfig.SHOP_MODE) {
           if (!context.selectedTournaments.length) {
                document.body.classList.add('griglia-centrale-vuota');
           } else {
                document.body.classList.remove('griglia-centrale-vuota');
           }
       }
    }, [context.selectedTournaments]);
    
    useEffect(function() {
        switch (props.section) {
            case 'favorite-odds':
                context.openFavoriteOdds();
                break;
            case 'today-odds':
                timeLineData.data && context.setDaySelection(timeLineData?.data?.weekDays?.[0]);
                break;
        }
     }, [props.section,timeLineData]);

    useEffect(function() {
        window.setHeight();
        setAvailableSpaceForTables();
    });
    useEffect(() => {
        initTables();
        initStatsUtils();
        // Resetta la classi 'e-largo-centro' e griglia-centrale-vuota
        return () => {
            document.body.classList.remove('e-largo-centro');
            document.body.classList.remove('griglia-centrale-vuota');
        };
    }, []);

    return (
        <PrematchContext.Provider value={context}>
            <FavoriteTournamentsProvider>
                <CustomCols.Provider value={conf.coc || MAX_COLUMNS}>
                    <div className="container-fluid pagina-sport bg-grigio-chiaro padding-su-1x">
                        <div className="row no-gutters sport-griglia">
                            <Menu data={data} isLive={false} />
                            {function() {
                                switch (context.section) {
                                    case 'prematch-home':
                                        return (
                                            <>
                                                {context.selectedTournaments?.length > 0 ?
                                                    <PrematchHome data={data} selectedTournaments={context.selectedTournaments} match={context.match} openFromPath={props.openFromPath} />
                                                    :
                                                    <PrematchLanding fallback={<TopMatch openMatchLive={openMatchLive} openFromPath={props.openFromPath} />} />
                                                }
                                            </>
                                        );
                                    case 'top-match':
                                        return <PrematchLanding fallback={<TopMatch openMatchLive={openMatchLive} openFromPath={props.openFromPath} />} />;
                                    case 'print-odds':
                                        return <PrintOdds data={data} />;
                                    case 'print-extra-odds':
                                        return <PrintOdds data={data} />;
                                    case 'selection-menu':
                                        return <Selection data={data} selections={context.selections} />;
                                    case 'daily-match':
                                        return <MatchesBydate data={data} openFromPath={props.openFromPath} />;
                                    case 'prematch-no-events':
                                        return <PrematchNoEvents />;
                                     case 'favorite-odds':
                                        return <PrematchFavoriteOdds />; 
                                    case 'extra-events':
                                        return <ExtraEvents />;
                                    case 'event-search':
                                        return <ResultsFetcher data={data} isLive={false} search={context.searchData} />;            
                                    default:
                                        return <PrematchEmpty></PrematchEmpty>;
                                }
                            }()}
                            {/*<GeniusStreamingV3 fid={21600090222} confData={getBetgeniusV3StreamingProps()[0]} forceLogged={true}></GeniusStreamingV3>    */}                    
                            <Betslip />
                            <MatchSearchPopup />
                        </div>
                    </div>
                </CustomCols.Provider>
            </FavoriteTournamentsProvider>
        </PrematchContext.Provider>
    );
}

export default Prematch;